module.exports = "<div ng-switch=\"ctrl.friendlyStatus\">\n  <div ng-switch-when=\"scheduledConfirmed|scheduledUnconfirmed\" ng-switch-when-separator=\"|\" class=\"ut-bar-scheduled\">\n    <scheduled-bar ctrl=\"ctrl\"></scheduled-bar>\n  </div>\n  <div ng-switch-default class=\"ut-bar-adjustment\">\n    <adjustment-bar ctrl=\"ctrl\"></adjustment-bar>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/receiptBar.html
// module id = 759
// module chunks = 0